// @ts-nocheck
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  Grid,
} from '@material-ui/core';
import ButtonWithLoader from 'commons/containers/ButtonWithLoader';
import { selectState, actionProps } from '../../../../utils/reduxActions';
import { lotsActions } from '../../reducer';
import connectSaga from '../../../../utils/saga';
import saga from '../../saga';
// material

// components
import { clone } from '../../../../utils/functions';

import { useTranslation } from 'react-i18next';

function WarehouseMovementForm(props) {
  const { t } = useTranslation();
  const { warehouses, lotId, formControls, actions, formIsOpen: isOpen } = props;

  const toggleForm = () => {
    actions.toggleForm();
  };

  const changeControls = (event) => {
    actions.changeControls({ [event.currentTarget.id]: event.target.value });
  };

  const submit = () => {
    actions.submitWarehouseMovement(lotId, formControls);
  };

  return (
    <Dialog fullWidth onClose={toggleForm} open={isOpen}>
      <DialogTitle>{t('Change warehouse title')}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item sm={6} xs={12}>
            <FormControl fullWidth>
              <InputLabel id="warehouse-input-label">{t('Warehouse')}</InputLabel>
              <Select
                labelId="warehouse-input-label"
                fullWidth
                value={formControls.warehouseId}
                onChange={changeControls}>
                <MenuItem id="warehouseId" value="">
                  {t('None')}
                </MenuItem>
                {warehouses.map((warehouse) => (
                  <MenuItem
                    key={`warehouse-form-option-${warehouse.id}`}
                    id="warehouseId"
                    value={warehouse.id}>
                    {warehouse.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={toggleForm} color="primary">
          {t('Cancel')}
        </Button>
        <ButtonWithLoader onClick={submit} autoFocus buttonId="lot-warehouse-movement">
          {t('Modify')}
        </ButtonWithLoader>
      </DialogActions>
    </Dialog>
  );
}

const withSaga = connectSaga({ key: 'sagaLots', saga });

const withConnect = connect(
  selectState('lots.lotId', 'lots.formControls', 'lots.formIsOpen'),
  actionProps(
    clone(clone.OBJECT, {
      submitWarehouseMovement: lotsActions.submitWarehouseMovement,
      changeControls: lotsActions.changeControls,
      toggleForm: lotsActions.toggleForm,
    }),
  ),
);

export default compose(withConnect)(withSaga(WarehouseMovementForm));
